export const MuiListItemIcon = (palette) => ({
    root: {
        color: palette.semantic.colorIconDefault,
        minWidth: '32px',
        '& .small': { fontSize: '1rem' },
    },
});
